import { createFileRoute, redirect } from '@tanstack/react-router';
import { ENV_MODE } from 'src/utils';

const IndexPage = () => {
  return null;
};

export const Route = createFileRoute('/')({
  component: IndexPage,
  beforeLoad: async () => {
    // BNC is not using the default login page,
    // so we need to redirect them to the creator login page
    redirect({
      to: ENV_MODE === 'bnc' ? '/creator-login' : '/login',
      throw: true,
    });
  },
});
